import { TIME_DAY, TIME_NIGHT } from 'app/constants/AppConstants';

export default class ButtonToggleTime extends Phaser.Group {
  constructor(game) {
    super(game);

    this.time = TIME_DAY;
    this.onToggle = new Phaser.Signal();

    //
    this.createContent();

    //
    this.bgDay.inputEnabled = true;
    this.bgDay.input.pixelPerfectClick = true;
    this.bgDay.input.useHandCursor = true;
    this.bgDay.events.onInputDown.add(this.handleInputDown, this);
    this.canTap = true;
  }

  /* eslint-disable max-statements */
  createContent() {
    this.bgDay = this.game.make.image(0, 0, 'ui_toggle_time', 'bg_day');
    this.bgDay.anchor.set(0.5);

    this.bgNight = this.game.make.image(0, 0, 'ui_toggle_time', 'bg_night');
    this.bgNight.anchor.set(0.5);

    this.frame = this.game.make.image(0, 0, 'ui_toggle_time', 'frame');
    this.frame.anchor.set(0.5);

    this.stars = this.game.make.image(0, 0, 'ui_toggle_time', 'stars');
    this.stars.anchor.set(0.5);

    this.rays = this.game.make.image(0, 0, 'ui_toggle_time', 'sun_rays');
    this.rays.anchor.set(0.5);

    // sun and moon
    this.sun = this.game.make.image(0, 0, 'ui_toggle_time', 'sun');
    this.sun.anchor.set(0.5, 1);

    this.moon = this.game.make.image(0, 0, 'ui_toggle_time', 'moon');
    this.moon.anchor.set(0.5, 1);
    this.moon.angle = 180;

    this.container = this.game.make.group();
    this.container.y = 69;
    this.container.addChild(this.sun);
    this.container.addChild(this.moon);

    this.maskGr = this.game.make.graphics();
    this.maskGr.beginFill(0xff0000);
    this.maskGr.drawCircle(0, 0, 90);
    this.maskGr.endFill();

    this.container.mask = this.maskGr;

    //
    this.bgNight.alpha = 0;
    this.stars.alpha = 0;

    //
    this.addChild(this.bgDay);
    this.addChild(this.bgNight);
    this.addChild(this.container);
    this.addChild(this.maskGr);
    this.addChild(this.frame);
    this.addChild(this.rays);
    this.addChild(this.stars);
  }
  /* eslint-enable */

  enable() {
    this.bgDay.input.enabled = true;
  }

  disable() {
    this.bgDay.input.enabled = false;
  }

  setNight() {
    this.time = TIME_NIGHT;
    this.rays.alpha = 0;
    this.bgNight.alpha = 1;
    this.container.angle = 180;
    this.stars.alpha = 1;
  }

  handleInputDown() {
    if (!this.canTap) {
      return;
    }
    this.canTap = false;

    //
    this.time = this.time === TIME_DAY ? TIME_NIGHT : TIME_DAY;
    this.onToggle.dispatch(this.time);

    // animate
    if (this.time === TIME_NIGHT) {
      // switch to night
      this.game.add.tween(this.rays).to({ alpha: 0 }, 100, Phaser.Easing.Quadratic.Out, true);
      this.game.add.tween(this.bgNight).to({ alpha: 1 }, 500, null, true);
      this.game.add.tween(this.container).to({ angle: -180 }, 400, null, true, 100);
      this.game.add
        .tween(this.stars)
        .to({ alpha: 1 }, 100, null, true, 500)
        .onComplete.add(this.handleAnimNightEnd, this);
    } else {
      // switch to day
      this.game.add.tween(this.stars).to({ alpha: 0 }, 100, Phaser.Easing.Quadratic.Out, true);
      this.game.add.tween(this.bgNight).to({ alpha: 0 }, 500, null, true);
      this.game.add.tween(this.container).to({ angle: 0 }, 400, null, true, 100);
      this.game.add
        .tween(this.rays)
        .to({ alpha: 1 }, 100, null, true, 500)
        .onComplete.add(this.handleAnimDayEnd, this);
    }
  }

  handleAnimNightEnd() {
    this.canTap = true;
    this.container.angle = 180;

    this.game.sounds.playSFX('generic_night', { spriteID: 'sfx' });
  }

  handleAnimDayEnd() {
    this.canTap = true;
    this.container.angle = 0;

    this.game.sounds.playSFX('generic_day', { spriteID: 'sfx' });
  }
}
